"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var components_1 = require("../../components");
var antd_1 = require("antd");
var ReceiverRequirements_1 = require("../../types/ReceiverRequirements");
var form_item_1 = __importDefault(require("../form-item"));
var react_intl_1 = require("react-intl");
var icons_1 = require("@ant-design/icons");
// import {defineMessages} from "react-intl.macro"
var payment_method_1 = require("../payment-method");
var form_item_2 = require("../form-item");
var antd_mask_input_1 = require("antd-mask-input");
var axios_1 = __importDefault(require("axios"));
var lodash_1 = require("lodash");
var ApiUtility_1 = require("../../../utils/ApiUtility");
var translationMessages = react_intl_1.defineMessages({
    supplier_title: {
        id: "supplier_title",
        defaultMessage: "Supplier",
    },
    supplier_name: {
        id: "supplier_name",
        defaultMessage: "Supplier name",
    },
    supplier_identifier: {
        id: "supplier_identifier",
        defaultMessage: "Supplier identifier"
    },
    supplier_vatNumber: {
        id: "supplier_vatNumber",
        defaultMessage: "VAT no"
    },
    supplier_notVatRegistered: {
        id: "supplier_notVatRegistered",
        defaultMessage: "Not VAT registered"
    },
    supplier_address_streetNameAndNumber: {
        id: "supplier_address_streetNameAndNumber",
        defaultMessage: "Address"
    },
    supplier_address_zip_postalCode: {
        id: "supplier_address_zip_postalCode",
        defaultMessage: "Zip/Postal code"
    },
    supplier_address_city: {
        id: "supplier_address_city",
        defaultMessage: "City"
    },
    supplier_address_countryCode: {
        id: "supplier_address_countryCode",
        defaultMessage: "Country code"
    },
    supplier_contact_email: {
        id: "supplier_contact_email",
        defaultMessage: "E-mail"
    },
    supplier_contact_email_title: {
        id: "supplier_contact_email_title",
        defaultMessage: "A payment notification will be sent to this email address" // "Send verður greiðslutilkynning á þetta netfang"
    },
    supplier_contact_name: {
        id: "supplier_contact_name",
        defaultMessage: "Contact name"
    },
    supplier_contact_phoneNumber: {
        id: "supplier_contact_phoneNumber",
        defaultMessage: "Phone number"
    },
    supplier_notValidEmail: {
        id: "supplier_notValidEmail",
        defaultMessage: "This is not a valid E-Mail"
    },
    validationRule_kennitalaPattern: {
        id: "validationRule_kennitalaPattern",
        defaultMessage: "Identifier must match pattern 111111-1111"
    },
    supplier_vatNumber_mandatory: {
        id: "supplier_vatNumber_mandatory",
        defaultMessage: "VAT number is required if some document lines are using any tax category type other than 'Outside tax scope'"
    },
});
var Supplier = function (props) {
    var _a = react_1.useState(false), isLoadingParticipantInfo = _a[0], setIsLoadingParticipantInfo = _a[1];
    var _b = react_1.useState({}), participantInfo = _b[0], setParticipantInfo = _b[1];
    var electronicMailLabelNode = (React.createElement(antd_1.Tooltip, { title: props.intl.formatMessage(translationMessages.supplier_contact_email_title), placement: "right" },
        React.createElement("span", null,
            props.intl.formatMessage(translationMessages.supplier_contact_email),
            "\u00A0",
            React.createElement(icons_1.QuestionCircleOutlined, null))));
    var getRequiredVatNumber = function () {
        // const fieldsValueAll = props.form.getFieldsValue();
        // if (fieldsValueAll.hasOwnProperty("invoice")) {
        //     if (fieldsValueAll.invoice.hasOwnProperty("invoiceLines")) {
        //         const invoiceLines: BillingLineMetadata[] = fieldsValueAll.invoice.invoiceLines;
        //         return invoiceLines.some(billingLine => {
        //             if (billingLine) {
        //                 return (billingLine.taxCategoryType !== TaxCategoryTypeEnum.OutsideTaxScope);
        //             }
        //         })
        //     }
        // }
        // return true;
        return !props.outsideVatScope;
    };
    react_1.useEffect(function () {
        if (participantInfo !== null && participantInfo !== undefined) {
            // TODO: this will override the Form Initial values. consider changing so that it only overrides if there is a value
            props.form.setFieldsValue({
                invoice: {
                    supplier: {
                        name: participantInfo.legalName,
                        address: {
                            streetNameAndNumber: participantInfo.streetAndNumber,
                            postalZone: participantInfo.postalCode,
                            city: participantInfo.city,
                        },
                    }
                },
            });
        }
    }, [isLoadingParticipantInfo]);
    var getParticipantInfoWithIdentifier = function (rapiUrl, token, searchValue) {
        setIsLoadingParticipantInfo(true);
        var constructedUrl = rapiUrl + "/api/v1/participants/0196:" + searchValue + "/registrations";
        axios_1.default.get(constructedUrl, {
            cancelToken: ApiUtility_1.getCancelToken("referenceIdentifierValueSearch"),
            headers: {
                "Authorization": "Bearer " + token
            }
        })
            .then(function (response) {
            setParticipantInfo(response.data);
            setIsLoadingParticipantInfo(false);
        })
            .catch(function (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                if (error.response.status === 404) {
                    antd_1.message.warning("Fann ekki uppl\u00FDsingar um nafn og heimilisfang a\u00F0ila \u00FAt fr\u00E1 innsleginni kennit\u00F6lu");
                }
                else {
                    antd_1.message.error(error.response.statusText);
                }
                // message.error(error.response.data.message);
            }
            else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                var request = error.request;
                antd_1.message.error(request.responseText);
            }
            else {
                // Something happened in setting up the request that triggered an Error
                antd_1.message.error(error.message);
            }
            setParticipantInfo({});
            setIsLoadingParticipantInfo(false);
        });
        return participantInfo;
    };
    var debouncerSearch = lodash_1.debounce(function (rapiUrl, rapiApiKey, searchValue) {
        var strippedSearchValue = searchValue.replace(/[_-]/g, "");
        if (strippedSearchValue.length >= 10) {
            getParticipantInfoWithIdentifier(rapiUrl, rapiApiKey, strippedSearchValue);
        }
    }, 500);
    var getSupplierTelephoneFieldDefinitions = function (receiverRequirements) {
        return receiverRequirements && receiverRequirements.fieldDefinitions.find(function (fieldRequirement) { return fieldRequirement.key === "supplier.contact.telephone"; });
    };
    return (React.createElement(components_1.ComponentContainer, { title: props.intl.formatMessage(translationMessages.supplier_title) },
        React.createElement(form_item_1.default, { receiverRequirements: props.receiverRequirements, receiverRequirementsKey: ReceiverRequirements_1.AvailableFields["supplier.identifier"], defaultLabel: props.intl.formatMessage(translationMessages.supplier_identifier), defaultIsRequired: true, fieldName: ["invoice", "supplier", "identifier"], hasFeedback: isLoadingParticipantInfo, validateStatus: isLoadingParticipantInfo ? "validating" : undefined, rules: [
                {
                    pattern: /\d{6}-\d{4}/g,
                    message: props.intl.formatMessage(translationMessages.validationRule_kennitalaPattern)
                },
                {
                    required: true,
                    message: props.intl.formatMessage(form_item_2.translationMessages.formItem_required_errorMessage),
                }
            ] },
            React.createElement(antd_mask_input_1.MaskedInput, { mask: "111111-1111", onChange: function (value) { return debouncerSearch(props.rapiBaseUrl, props.rapiApiKey, value.target.value); } })),
        React.createElement(form_item_1.default, { receiverRequirements: props.receiverRequirements, receiverRequirementsKey: ReceiverRequirements_1.AvailableFields["supplier.name"], defaultLabel: props.intl.formatMessage(translationMessages.supplier_name), defaultIsRequired: true, fieldName: ["invoice", "supplier", "name"] },
            React.createElement(antd_1.Input, { disabled: isLoadingParticipantInfo })),
        React.createElement(form_item_1.default, { receiverRequirements: props.receiverRequirements, receiverRequirementsKey: ReceiverRequirements_1.AvailableFields["supplier.vatNumber"], defaultLabel: props.intl.formatMessage(translationMessages.supplier_vatNumber), defaultIsRequired: false, fieldName: ["invoice", "supplier", "vatNumber"], dependencies: ["invoice", "invoiceLines"], additionalRules: [
                {
                    required: getRequiredVatNumber(),
                    message: props.intl.formatMessage(translationMessages.supplier_vatNumber_mandatory) // VAT number is required if some document lines are using any tax category type other than "outside tax scope"
                },
                {
                    max: 6,
                    min: 5,
                    message: props.intl.formatMessage(payment_method_1.translationMessages.paymentMethod_rules_Length, {
                        fieldName: props.intl.formatMessage(translationMessages.supplier_vatNumber),
                        min: 5,
                        max: 6
                    })
                }
            ] },
            React.createElement(antd_1.Input, { disabled: isLoadingParticipantInfo || props.outsideVatScope })),
        React.createElement(antd_1.Form.Item, { name: "outsideVatScope", label: props.intl.formatMessage(translationMessages.supplier_notVatRegistered), valuePropName: "checked" },
            React.createElement(antd_1.Checkbox, { onChange: function (e) { return props.setOutsideVatScope(e.target.checked); } })),
        React.createElement(form_item_1.default, { receiverRequirements: props.receiverRequirements, receiverRequirementsKey: ReceiverRequirements_1.AvailableFields["supplier.address.streetNameAndNumber"], defaultLabel: props.intl.formatMessage(translationMessages.supplier_address_streetNameAndNumber), defaultIsRequired: true, fieldName: ["invoice", "supplier", "address", "streetNameAndNumber"] },
            React.createElement(antd_1.Input, { disabled: isLoadingParticipantInfo })),
        React.createElement(form_item_1.default, { receiverRequirements: props.receiverRequirements, receiverRequirementsKey: ReceiverRequirements_1.AvailableFields["supplier.address.postalZone"], defaultLabel: props.intl.formatMessage(translationMessages.supplier_address_zip_postalCode), defaultIsRequired: true, fieldName: ["invoice", "supplier", "address", "postalZone"] },
            React.createElement(antd_1.Input, { disabled: isLoadingParticipantInfo })),
        React.createElement(form_item_1.default, { receiverRequirements: props.receiverRequirements, receiverRequirementsKey: ReceiverRequirements_1.AvailableFields["supplier.address.city"], defaultLabel: props.intl.formatMessage(translationMessages.supplier_address_city), defaultIsRequired: false, fieldName: ["invoice", "supplier", "address", "city"] },
            React.createElement(antd_1.Input, { disabled: isLoadingParticipantInfo })),
        React.createElement(form_item_1.default, { receiverRequirements: props.receiverRequirements, receiverRequirementsKey: ReceiverRequirements_1.AvailableFields["supplier.address.countryCode"], defaultLabel: props.intl.formatMessage(translationMessages.supplier_address_countryCode), defaultIsRequired: true, fieldName: ["invoice", "supplier", "address", "countryCode"] },
            React.createElement(antd_1.Input, { disabled: true })),
        React.createElement(form_item_1.default, { receiverRequirements: props.receiverRequirements, receiverRequirementsKey: ReceiverRequirements_1.AvailableFields["supplier.contact.name"], defaultLabel: props.intl.formatMessage(translationMessages.supplier_contact_name), defaultIsRequired: false, fieldName: ["invoice", "supplier", "contact", "name"] },
            React.createElement(antd_1.Input, { disabled: isLoadingParticipantInfo })),
        React.createElement(form_item_1.default, { receiverRequirements: props.receiverRequirements, receiverRequirementsKey: ReceiverRequirements_1.AvailableFields["supplier.contact.electronicMail"], defaultLabel: electronicMailLabelNode, defaultIsRequired: false, fieldName: ["invoice", "supplier", "contact", "electronicMail"], additionalRules: [
                {
                    type: 'email',
                    message: props.intl.formatMessage(translationMessages.supplier_notValidEmail),
                }
            ] },
            React.createElement(antd_1.Input, { disabled: isLoadingParticipantInfo })),
        getSupplierTelephoneFieldDefinitions(props.receiverRequirements) ? (React.createElement(form_item_1.default, { receiverRequirements: props.receiverRequirements, receiverRequirementsKey: ReceiverRequirements_1.AvailableFields["supplier.contact.telephone"], defaultLabel: props.intl.formatMessage(translationMessages.supplier_contact_phoneNumber), defaultIsRequired: false, fieldName: ["invoice", "supplier", "contact", "telephone"] },
            React.createElement(antd_1.Input, null)))
            : null));
};
var SupplierIntl = react_intl_1.injectIntl(Supplier);
exports.default = SupplierIntl;
